import { animate, style, transition, trigger } from "@angular/animations";
import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ViewRef
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroExclamationCircle } from '@ng-icons/heroicons/outline';
import { DropDownFilterSettings, DropDownListComponent, KENDO_COMBOBOX, KENDO_DROPDOWNLIST } from "@progress/kendo-angular-dropdowns";
import { KENDO_ICONS } from "@progress/kendo-angular-icons";
import { KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { KENDO_LABELS } from "@progress/kendo-angular-label";
import * as CryptoJS from 'crypto-js';
import { parseISO, set } from 'date-fns';
import { format, toZonedTime } from 'date-fns-tz';
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderModule, NgxUiLoaderService } from "ngx-ui-loader";
import { catchError, delay, map, merge, of, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { ClientServices } from "../../@theme/services/clients.service";
import { InitUserService } from "../../@theme/services/init-user.service";
import { TypesServices } from "../../@theme/services/typeslist.service";
import { repingDto } from "./constructDto/transactionDto";
import { Step2TransactionFormComponent } from "./step2Transactions/step2Transactions.component";
@Component({
  selector: "gd-addtrans",
  styleUrls: ["./Transaction.component.css"],
  templateUrl: "./Transaction.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("fade", [
      transition("void => *", [
        style({ opacity: 0 }),
        animate(2000, style({ opacity: 1 }))
      ]),
      transition("* => void", [animate(1000, style({ opacity: 0 }))])
    ])
  ],
  imports: [CommonModule, NgxUiLoaderModule, KENDO_ICONS, KENDO_INPUTS, KENDO_LABELS, KENDO_COMBOBOX, FormsModule, ReactiveFormsModule, KENDO_DROPDOWNLIST, Step2TransactionFormComponent, NgIcon],
  providers: [
    provideIcons({ heroExclamationCircle })
  ]
}) //   imports: [NgxUiLoaderModule, NgIf, FormsModule, ReactiveFormsModule,  NgClass, ComboBoxComponent, FilterDirective, KENDO_DROPDOWNLIST,  Step2TransactionFormComponent]
export class TransactionsComponent implements OnInit, AfterViewInit {
  public lblRep: string;
  unsubcribe: any;
  selectedValuerepcodeId: any;
  @ViewChild("repsel") repsel: DropDownListComponent;
  @Output() passclientId = new EventEmitter<any>();
  @Output() submitEvent = new EventEmitter<any>();
  @ViewChild("item", { static: false }) accordion: any;
  public repNamestring: string;
  public TransactionData: any;
  public RepcodeIdSel: number;
  public opened = false;
  public readonlyifeditTransaction = true;
  public StatusTypeId: any;
  public continuechanges = false;
  public tester = 0;
  public LiquidNWTo: string;
  public repwasterminated: boolean;
  public LiquidNWFrom: string;
  public NetWorthTo: string;
  private SplitRepIdchange: number;
  private copydata: any;
  private counter = 0;
  public NetWorthFrom: string;
  public AnnualIncTo: string;
  public AnnualIncFrom: string;
  public queryEdit = true;
  public InvestmentProfileId: number;
  public InvestmentTimeHorizonId: number;
  public LiquidityNeedsId: number;
  public InvObjectiveId: number;
  private newosjresult: number;
  private cnt: number;
  public lblRepCode: string;
  public lblClientName: string;
  public lblProductType: string;
  public ProdTypeId: string;
  public lblSourceOffundsType: string;
  public lblTransactionType: string;
  public lblSplitRepName: string;
  firstForm: FormGroup;
  secondForm: FormGroup;
  thirdForm: FormGroup;
  public showtrue: boolean;
  private producttypeIdEdit: number;
  private getClientId: number;
  private getRepId: number;
  public showsplit: boolean;
  public onVal: boolean;
  public selectRep: number;
  public loader: boolean;
  public loaderCode: boolean;
  public loaderTypeClient: boolean;
  public loaderpt: boolean;
  public RepExists: boolean;
  public loadetrans: boolean;
  public statusIndex0: string;
  public clientlistItems: Array<any> = [];
  public repcodelistItems: Array<any> = [];
  public clientthirdlisting: Array<any> = [];
  public productlisting: Array<any> = [];
  public translisting: Array<any> = [];
  public sourceFundtypelist: Array<any> = [];
  private duration = 1000;
  public versionbtn: string;
  public style1: boolean;
  public style2: boolean;
  public style3: boolean;
  public style4: boolean;
  public style5: boolean;
  private index = 0;
  public style6: boolean;
  public style7: boolean;
  public style8: boolean;
  public style9: boolean;
  public style10: boolean;
  public style11: boolean;
  public style12: boolean;
  public source: boolean;
  public radstatus: string;
  private roleString: string;
  public sourceselect = false;
  public RepSelected: number;
  public ClientSelected: number;
  public productTypeSelected: number;
  public sourceselecttransfer = false;
  public editsource = false;
  public btnupdate: boolean;
  public transactionTypeSelected: number;
  public SourceofFundsSelected: number;
  public RepCodeSelected: number;
  public repCodestring: string;
  public Clientstring: string;
  public productTypestring: string;
  public stateof: string;
  public transactionTypestring: string;
  public sourceoffundsstring: string;
  public LiquidDescription: string;
  public InvestDescription: string;
  public InvestmentTimeHorizonDescription: string;
  public ProfileDescription: string;
  public SplitRepTransaction: boolean;
  public taxen: string;
  public clientId: number;
  public showTopRow: boolean;
  public dob: string;
  public transactionTypeId: number;
  public address1: string;
  public address2: string;
  public city: string;
  public state: string;
  public zipcode: string;
  public Email: string;
  public ptypes: number;
  private getname: string;
  public blotterIdget: number;
  public showbtn: boolean;
  private RepId: number;
  private currentRole: string;
  public osjValid = false;
  public checkWarning = false;
  public checkWarningShowmsg = false;
  public checkReviewmsg = false;
  public reloadStep2 = true;
  public accountformTrue = false;
  private storageValueReturn: string;
  public loading = false;
  public loadingDelete = false;
  options = [
    { value: "true", label: "Yes" },
    { value: "false", label: "No" }
  ];
  option: any;
  public selectedItem: number = this.productlisting[1];
  public virtual: any = {
    itemHeight: 30
  };
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: "startsWith"
  };
  constructor(
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private cliservice: ClientServices,
    private ngxService: NgxUiLoaderService,
    private typ: TypesServices,
    private initUserService: InitUserService
  ) {
    this.RepExists = true;
    this.firstForm = this.fb.group({
      RepId: ["", Validators.required],
      repCodeId: ["", Validators.required],
      clientTax: new FormControl({ value: "", disabled: true }),
      productTypeId: new FormControl({ value: "", disabled: true }),
      transact: ["", Validators.required],
      sourcetypes: ["", Validators.required],
      SplitRepId2: ["", Validators.required],
      SplitRepId: [""],
      Amount: [0, [Validators.min(0), Validators.max(999999999)]]
    });
  }
  ngOnInit() {
    this.storageValueReturn = localStorage.getItem("rvarietylist");
    this.firstForm = this.fb.group({
      RepId: ["", Validators.required],
      repCodeId: ["", Validators.required],
      clientTax: ["", Validators.required],
      productTypeId: new FormControl({ value: "", disabled: true }),
      transact: ["", Validators.required],
      sourcetypes: ["", Validators.required],
      SplitRepId2: ["", Validators.required],
      SplitRepId: [""],
      firstName: [""],
      Amount: [0, [Validators.min(0), Validators.max(999999999)]]
    });
    this.secondForm = this.fb.group({
      secondCtrl: ["", Validators.required]
    });
    this.thirdForm = this.fb.group({
      thirdCtrl: ["", Validators.required]
    });
    this.firstForm.controls["transact"].setValue(1);
    this.SplitRepTransaction = this.showsplit;
    this.repwasterminated = false;
    this.cnt = 0;
    this.loaderpt = true;
    this.source = false;
    this.onVal = false;
    this.radstatus = "danger";
    this.firstForm.get("SplitRepId2").setValue("false");
    sessionStorage.removeItem("changeoftype");
    this.showbtn = true;
    sessionStorage.removeItem("types");
  }
  ngAfterViewInit(): void {
    this.loaderfirst();
    if (this.route.snapshot.queryParams["RviewAccount"]) {
      const PauseEachLine = of(null);
      this.queryEdit = false;
      this.showTopRow = false;
      this.route.queryParams.subscribe((params) => {
        CryptoJS.AES.decrypt(
          params["RviewAccount"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        this.blotterIdget = 0;
        const getRepIds = CryptoJS.AES.decrypt(
          params["rId"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        this.RepId = Number(getRepIds);
        const getclientId = CryptoJS.AES.decrypt(
          params["clientId"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        const getrepCodeId = CryptoJS.AES.decrypt(
          params["repCodeId"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        const gettransaction = CryptoJS.AES.decrypt(
          params["transaction"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        const getproducttype = CryptoJS.AES.decrypt(
          params["product"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        if (params["stadeId"]) {
          const stateofword =
            CryptoJS.AES.decrypt(
              params["stateId"],
              `${environment.securepw}`
            ).toString(CryptoJS.enc.Utf8) ?? null;
          this.stateof = stateofword;
        }
        this.clientId = Number(getRepIds);
        merge(
          PauseEachLine.pipe(
            map(
              (
                (cliList) => () =>
                  cliList
              )(
                this.GetClientListEdit(
                  getRepIds,
                  Number(getclientId),
                  Number(0) // c[0]['splitRepId']
                )
              )
            )
          ), // gettransaction
          PauseEachLine.pipe(
            map(
              (
                (setprodId) => () =>
                  setprodId
              )(
                this.firstForm.get("transact").setValue(Number(gettransaction)) //Number(c[0]['productTypeId'])
              )
            ),
            delay(1000)
          ),
          PauseEachLine.pipe(
            map(
              (
                (setprodId) => () =>
                  setprodId
              )(
                this.firstForm
                  .get("productTypeId")
                  .setValue(Number(getproducttype)) //Number(c[0]['productTypeId'])
              )
            ),
            delay(1000)
          ),
          PauseEachLine.pipe(
            map(
              (
                (setclientId) => () =>
                  setclientId
              )(this.firstForm.get("clientTax").setValue(Number(getclientId)))
            ),
            delay(1000)
          ),
          PauseEachLine.pipe(
            map(
              (
                (setrepcodeId) => () =>
                  setrepcodeId
              )(
                this.firstForm
                  .get("repCodeId")
                  .setValue(Number(getrepCodeId) ?? 0)
              )
            ),
            delay(1000)
          ),
          PauseEachLine.pipe(
            map(
              (
                (selectTypes) => () =>
                  selectTypes
              )()
            ),
            delay(1000)
          ),
          PauseEachLine.pipe(
            map(
              (
                (checkhere) => () =>
                  checkhere
              )() // this.checkId()
            ),
            delay(1000)
          )
        );
      });
      this.firstForm.controls["firstName"].setValue("none");
      this.firstForm.controls["sourcetypes"].setValue(0);
      this.firstForm.controls['clientTax'].disable();
      this.firstForm.controls['repCodeId'].disable();
      this.firstForm.controls['transact'].disable();
      this.firstForm.controls['productTypeId'].disable();
      this.firstForm.controls['SplitRepId'].disable();
      this.firstForm.get("SplitRepId2").disable();
      this.checkWarningShowmsg = false;
      this.checkReviewmsg = false;
      return;
    }
    if (this.route.snapshot.queryParams["Rview"]) {
      const PauseEachLine = of(null);
      this.queryEdit = false;
      this.showTopRow = false;
      this.route.queryParams.subscribe((params) => {
        const getblotterClient = CryptoJS.AES.decrypt(
          params["Rview"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        this.blotterIdget = Number(getblotterClient);
        const getrepcodeId = CryptoJS.AES.decrypt(
          params["repCodeId"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        const getRepIds = CryptoJS.AES.decrypt(
          params["rId"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        this.RepId = Number(getRepIds);
        const param = { blotId: getblotterClient };
        CryptoJS.AES.decrypt(
          params["clientId"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        if (params["stateId"]) {
          const stateofword =
            CryptoJS.AES.decrypt(
              params["stateId"],
              `${environment.securepw}`
            ).toString(CryptoJS.enc.Utf8) ?? null;
          this.stateof = stateofword;
        }
        this.clientId = Number(getRepIds);
        //   alert(getrepcodeId)
        /*
         * Selects Dropdowns after data received.
         * Allow to fill each type down in order.
         * Blotter row Id
         * */
        this.cliservice.RetrieveBlotterInfo(param).subscribe((c) => {
          merge(
            PauseEachLine.pipe(
              map(
                (
                  (cliList) => () =>
                    cliList
                )(
                  this.GetClientListEdit(
                    getRepIds,
                    Number(c[0]["clientId"]),
                    Number(c[0]["splitRepId"])
                  )
                )
              )
            ),
            PauseEachLine.pipe(
              map(
                (
                  (setprodId) => () =>
                    setprodId
                )(
                  this.firstForm
                    .get("productTypeId")
                    .setValue(Number(c[0]["productTypeId"]))
                )
              ),
              delay(500)
            ),
            PauseEachLine.pipe(
              map(
                (
                  (setclientId) => () =>
                    setclientId
                )(
                  this.firstForm
                    .get("clientTax")
                    .setValue(Number(c[0]["clientId"]))
                )
              ),
              delay(500)
            ),
            PauseEachLine.pipe(
              map(
                (
                  (setrepcodeId) => () =>
                    setrepcodeId
                )(
                  this.firstForm.get("repCodeId").setValue(Number(getrepcodeId))
                )
              ),
              delay(500)
            ),
            PauseEachLine.pipe(
              // SplitRepId
              map(
                (
                  (selectTypes) => () =>
                    selectTypes
                )(
                  this.selectionChangeProductTypes(
                    { productTypeId: Number(c[0]["productTypeId"]) },
                    Number(c[0]["sourceOfFundsId"]),
                    Number(c[0]["transactionTypeId"]),
                    Number(c[0]["splitRepTransaction"]),
                    Number(c[0]["splitRepId"]),
                    Number(c[0]["repCodeId"])
                  )
                )
              ),
              delay(500)
            ),
            PauseEachLine.pipe(
              map(
                (
                  (checkhere) => () =>
                    checkhere
                )(this.checkId())
              ),
              delay(500)
            )
          );
        });
      });
      this.firstForm.controls['clientTax'].disable();
      this.firstForm.controls['repCodeId'].disable();
      this.firstForm.controls['SplitRepId'].disable();
      this.firstForm.get("SplitRepId2").disable();
    } else {
      this.showTopRow = true;
      this.firstForm.controls['clientTax'].disable();
    }
    return;
  }
  loaderfirst() {
    this.handleStorageValueReturn();
    this.handleQueryParams();
  }
  handleStorageValueReturn() {
    if (this.storageValueReturn) {
      const decryptedValue = this.decrypt(
        this.storageValueReturn,
        environment.securepw
      );
      if (decryptedValue.toLowerCase() === "rep") {
        this.RepExists = false;
      } else {
        this.RepExists = true;
      }

      this.cliservice
        .getproductypelist({ role: decryptedValue })
        .pipe(
          tap((r) => {
            this.productlisting = r;
            this.loaderpt = false;
            this.updateProductControl();
            this.GetTransactionTypes();
          }),
          catchError((error) => {
            console.error("Error fetching product type list", error);
            return [];
          })
        )
        .subscribe();
    }

    if (
      !this.route.snapshot.queryParams["Rview"] &&
      !this.route.snapshot.queryParams["RviewAccount"]
    ) {
      localStorage.getItem("branch_num")
        ? this.GetClientListbyBranch()
        : this.GetClientList();
    }
  }
  handleQueryParams() {
    this.route.queryParams.subscribe((params) => {
      if (params["Rview"]) {
        this.handleRview(params);
      } else if (params["RviewAccount"]) {
        this.handleRviewAccount(params);
      } else if (params["R"]) {
        this.handleR(params);
      }
    });
  }

  handleRview(params: any) {
    this.blotterIdget = Number(
      this.decrypt(params["Rview"], environment.securepw)
    );
    this.getClientId = Number(
      this.decrypt(params["clientId"], environment.securepw)
    );
  }

  handleRviewAccount(params: any) {
    this.blotterIdget = 0;
    this.getClientId = Number(
      this.decrypt(params["clientId"], environment.securepw)
    );
  }

  handleR(params: any) {
    this.getClientId = Number(this.decrypt(params["R"], environment.securepw));
    this.getRepId = Number(this.decrypt(params["Rp"], environment.securepw));
  }

  decrypt(value: string, key: string): string {
    try {
      const bytes = CryptoJS.AES.decrypt(value, key)
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting value", error);
      return "";
    }
  }

  updateProductControl() {
    const prodControl = this.firstForm.get("productTypeId");
    if (prodControl) {
      const matchingProduct = this.productlisting.find(
        (t) => t.productTypeId === prodControl.value
      );
      if (matchingProduct) {
        prodControl.setValue(matchingProduct.productTypeId);
      }
    }
  }
  checkId() {
    if (this.getRepId === undefined) {
      if (this.firstForm.value.RepId) {
        this.style1 = false;
        this.style2 = true;
      } else {
        this.style1 = true;
        this.style2 = false;
      }
    } else {
      this.style1 = false;
      this.style2 = true;
    }
    if (this.firstForm.value.repCodeId) {
      this.style3 = false;
      this.style4 = true;
    } else {
      this.style3 = true;
      this.style4 = false;
    }
    if (this.getClientId === undefined) {
      if (this.firstForm.value.clientTax) {
        this.style5 = false;
        this.style6 = true;
      } else {
        this.style5 = true;
        this.style6 = false;
      }
    } else {
      this.style5 = false;
      this.style6 = true;
    }
    if (this.firstForm.value.productTypeId) {
      this.style7 = true;
      this.style8 = false;
    } else {
      this.style7 = false;
      this.style8 = true;
    }
    if (this.firstForm.value.transact) {
      this.style9 = false;
      this.style10 = true;
    } else {
      this.style9 = true;
      this.style10 = false;
    }
    if (this.firstForm.value.SplitRepId) {
      this.style11 = false;
      this.style12 = true;
    } else {
      this.style11 = true;
      this.style12 = false;
    }
    this.cdr.detectChanges();
  }
  GetClientList() {
    this.loader = true;
    this.cliservice.getRepListAll().subscribe((c) => {
      this.clientlistItems = c.map((item: any) => {
        return { ...item, fullName: `${item.lastName} ${item.firstName}` };
      });
      this.loader = false;
      if (this.getRepId !== undefined) {
        this.firstForm.get("RepId").setValue(Number(this.getRepId));
        this.GetRepCodeList(this.getRepId);
        this.GetClientListing(this.getRepId); // Get List of Reps
        this.firstForm.controls['RepId'].disable();
        this.firstForm.controls['productTypeId'].enable();
        this.style2 = true;
        this.firstForm.controls["SplitRepId"].setValue(0);
        const repNameSelect = this.clientlistItems.find(
          (x) => x.repId === Number(this.getRepId)
        );
        if (repNameSelect === undefined) {
          this.repwasterminated = true;
          this.firstForm.controls['RepId'].enable();
          return;
        }
        this.repNamestring = repNameSelect?.lastName;
        if (this.route.snapshot.queryParams["R"]) {
          this.route.queryParams.subscribe((params) => {
            if (params["R"]) {
              CryptoJS.AES.decrypt(
                params["R"],
                `${environment.securepw}`
              ).toString(CryptoJS.enc.Utf8)
              this.RepSelected = repNameSelect?.repId;
              this.repNamestring = repNameSelect?.lastName;
              this.Email = repNameSelect?.email;
            }
          });
        }
        return;
      }
    });
  }
  GetClientListbyBranch() {
    this.loader = true;
    const bNum = localStorage.getItem("branch_num");
    const convertbnumber = { branchNumber: Number(bNum) };
    this.cliservice.getClientListbyBranch(convertbnumber).subscribe((c) => {
      this.clientlistItems = c;
      this.loader = false;
      if (this.getRepId !== undefined) {
        this.firstForm.get("RepId").setValue(Number(this.getRepId));
        this.GetRepCodeList(this.getRepId);
        this.GetClientListing(this.getRepId);
        this.firstForm.controls['RepId'].disable();
        this.firstForm.controls['productTypeId'].enable();
        this.style2 = true;
        this.firstForm.get("SplitRepId").setValue(this.SplitRepIdchange);
        return;
      }
    });
  }
  GetClientListEdit(RepId: number, ClientId: number, SplitRepId: number) {
    this.loader = true;
    this.cliservice.getRepListAll().subscribe((c) => {
      this.clientlistItems = c.map((item: any) => {
        return { ...item, fullName: `${item.lastName} ${item.firstName}` };
      });
      this.loader = false;
      if (RepId !== undefined) {
        const getmyRepId = Number(RepId);
        this.RepId = getmyRepId;
        this.firstForm.get("RepId").setValue(getmyRepId);
        this.GetRepCodeList(getmyRepId);
        this.GetClientListing(RepId, ClientId); // Get list of Client
        if (!this.route.snapshot.queryParams["Rview"]) {
          this.firstForm.controls['RepId'].enable();
          this.firstForm.controls['productTypeId'].enable();
          this.firstForm.controls['transact'].enable();
          this.firstForm.controls['SplitRepId'].enable();
          this.firstForm.controls['sourcetypes'].enable();
        } else {
          this.firstForm.controls['RepId'].disable();
          this.firstForm.controls['productTypeId'].disable();
          this.firstForm.controls['transact'].disable();
          this.firstForm.controls['SplitRepId'].disable();
          this.firstForm.controls['sourcetypes'].disable();
          this.firstForm.get("SplitRepId2").disable();
        }
        this.style2 = true;
        this.SplitRepIdchange = SplitRepId;
        this.firstForm.get("SplitRepId").setValue(SplitRepId);
        //  this.firstForm.controls['SplitRepId'].setValue(0)
        const repNameSelect = this.clientlistItems.find(
          (x) => x.repId === Number(this.getRepId)
        );
        this.repNamestring = repNameSelect?.lastName;
        this.RepSelected = this.firstForm.value?.RepId;
        if (this.route.snapshot.queryParams["R"]) {
          this.route.queryParams.subscribe((params) => {
            if (params["R"]) {
              this.RepSelected = repNameSelect.repId;
              this.repNamestring = repNameSelect.lastName;
              this.Email = repNameSelect.email;
            }
          });
        }
        return;
      }
    });
  }

  toggleShowTopRow() {
    this.showTopRow = !this.showTopRow;
  }

  prev() {
    this.showtrue = false;
  }
  show2() {
    this.firstForm.controls["productTypeId"].setErrors({ incorrect: true });
  }
  show() {
    /*     if (this.firstForm.valid) {
      this.showtrue = true
    } */
    this.repwasterminated = false;
    this.RepSelected = this.getRepId
      ? this.getRepId
      : this.firstForm.value.RepId;
    this.lblRep = this.firstForm.value.transact;
    this.ClientSelected = this.getClientId
      ? this.getClientId
      : this.firstForm.value.clientTax;
    const param = {
      clientId: this.ClientSelected,
      repId: this.RepSelected,
      clientname: this.Clientstring
    };
    this.passclientId.emit(param);
    this.productTypeSelected =
      this.firstForm.value.productTypeId !== undefined
        ? this.firstForm.value.producTypeId
        : this.producttypeIdEdit;
    if (this.productTypeSelected === undefined) {
      this.productTypeSelected = this.firstForm.value.productTypeId;
    }
    this.transactionTypeSelected = this.firstForm.value.transact;
    this.SourceofFundsSelected = this.firstForm.value.sourcetypes;
    this.RepCodeSelected = this.firstForm.value.repCodeId;
    this.repCodestring = this.repcodelistItems.find(
      (f) => f.repCodeId === this.firstForm.value.repCodeId
    )?.repCode;
    this.productTypestring = this.productlisting.find(
      (f) => f.productTypeId === this.productTypeSelected
    )?.productTypeDesc2;
    this.transactionTypestring = this.translisting.find(
      (f) => f.transactionTypeId === this.transactionTypeSelected
    )?.transactionTypeDesc;
    this.sourceoffundsstring =
      this.SourceofFundsSelected === 0
        ? ""
        : this.sourceFundtypelist.find(
          (f) => f.sourceOfFundsTypeId === this.SourceofFundsSelected
        )?.sourceOfFundsTypeDesc;
    this.osjValidatorload();
  }
  GetRepCodeList(repcode: number) {
    this.loaderCode = true;
    const param = { RepId: repcode };
    this.cliservice.getRepCodeList(param).subscribe((r) => {
      this.repcodelistItems = r;
      this.loaderCode = false;
    });
  }
  GetClientListing(repcode: number, clientId?: number) {
    this.loaderTypeClient = true;
    const param = { RepId: repcode, ClientId: clientId };
    if (clientId !== undefined) {
      const clId = clientId.toString();
      localStorage.setItem("clId", clId.toString());
    }
    this.cliservice.getClientRepIdList(param).subscribe((r) => {
      this.clientthirdlisting = r;
      if (this.getClientId !== undefined) {
        setTimeout(
          () =>
            this.firstForm.get("clientTax").setValue(Number(this.getClientId)),
          1000
        );
        setTimeout(() => (this.loaderTypeClient = false), 1000);
        if (
          // come back to this.
          !this.route.snapshot.queryParams["Rview"] ||
          !this.route.snapshot.queryParams["RviewAccount"]
        ) {
          this.firstForm.controls['clientTax'].disable();
        }
        this.style6 = true;
        const paramVal = this.clientthirdlisting.filter(
          (x) => x.clientId === Number(this.getClientId)
        );
        this.selectionChangeClient(paramVal[0]);
        this.loaderTypeClient = false;
        return;
      } else {
        this.loaderTypeClient = false;
      }
    });
    //  this.cdr.detectChanges();
  }
  GetTransactionTypes() {
    this.loadetrans = true;
    this.cliservice.getTransactionTypelist().subscribe((r) => {
      this.translisting = r;
      this.translisting = this.translisting.filter(
        (t) => t.transactionTypeId !== 6
      );
      this.loadetrans = false;
    });
    this.firstForm.markAsDirty();
    this.showbtn = false;
  }
  GetSourceofFundTypes(value: number) {
    const param = { classID: value };
    this.cliservice.getsourceoffundtypelist(param).subscribe((r) => {
      this.sourceFundtypelist = r;
      this.ngxService.stopLoader("loader-03");
    });
    this.ngxService.stopLoader;
    this.firstForm.markAsDirty();
  }
  onFirstSubmit() {
    this.firstForm.markAsDirty();
  }
  public findInvalidControls() {
    const invalid = [];
    const controls = this.firstForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
        this.getname = name;
        this.showToaster(0);
      }
    }
    return invalid;
  }
  showToaster(duration) {
    this.toastrService.show(this.getname, `You are missing a value :`);
  }

  isBlank(str) {
    return !str || /^\s*$/.test(str);
  }
  async onSecondSubmit(b) {
    console.log('version=' + JSON.stringify(b))
    this.versionbtn = sessionStorage.getItem("version");
    this.TransactionData = b;
    this.continue(b);
  }
  async continue(b) {
    sessionStorage.removeItem("version");
    b = this.TransactionData;
    this.loading = true;
    this.loadingDelete = false;
    this.firstForm.value.valid = false;
    if (!this.isBlank(b.ccemails)) {
      if (!b.ccemails.isArray) {
        b.ccemails = ["" + b.ccemails + ""];
      }
    } else {
      b.ccemails = null;
    }
    if ((await this.osjValidatorload()) === false) {
      return false;
    }
    const x = b.Amount;
    const y: number = +x;
    b.Amount = y;
    b.ClientId = this.clientId
      ? this.clientId
      : this.firstForm.value.clientTax;
    b.ProductTypeId = Number(this.ProdTypeId)
      ? Number(this.ProdTypeId)
      : this.firstForm.value.productTypeId;
    b.TransactionTypeID = this.transactionTypeId
      ? this.transactionTypeId
      : this.firstForm.value.transact;
    b.SourceOfFundsID = this.SourceofFundsSelected;
    b.AnnualIncFrom = this.AnnualIncFrom;
    b.AnnualIncTo = this.AnnualIncTo;
    b.NetWorthFrom = this.NetWorthFrom;
    b.NetWorthTo = this.NetWorthTo;
    b.LiquidNwfrom = this.LiquidNWFrom;
    b.LiquidNWTo = this.LiquidNWTo;
    b.AccountName = 0;
    b.SplitRepTransaction = this.firstForm.value.SplitRepId2;
    b.SplitRepId = this.firstForm.value.SplitRepId;
    b.StatusTypeId = this.firstForm.value.StatusTypeID;
    b.RepCodeId = this.firstForm.value.repCodeId;
    b.RepId = this.RepSelected;
    b.blotterId = this.blotterIdget ? this.blotterIdget : 0;
    b.Email = this.Email;
    if (this.versionbtn === "Next") {
      this.copydata = {
        blotinfo: b,
        comments: b.comments,
        datesubmitted: b.DateSubmitted
      }
      b.AlertRepText = encodeURIComponent(b.AlertRepText);
      // console.log('statustype' + this.StatusTypeId + ' new status' + JSON.stringify(this.firstForm.value))
      //      console.log(JSON.stringify(param))
      //  this.copydata = param;
      this.cliservice.SubmitblotterInfo(this.copydata).subscribe({
        next: () => this.SubmitblotterInfoSuccess(),
        error: () => this.SubmitblotterInfoError()
      });
    }
    if (this.versionbtn === "Removious") {
      this.copydata = {
        blotinfo: b,
        comments: b.comments,
        datesubmitted: b.DateSubmitted
      };
   //   console.log('delete' + ' new status' + JSON.stringify(this.copydata))
      this.typ.DeleteTransactions(this.copydata).subscribe({
        next: () => this.SubmitblotterInfoSuccess(),
        error: () => this.SubmitblotterInfoError()
      });
    }
    return null;
  }
  SubmitblotterInfoSuccess() {
    // this method causes redirect to only show the edited transaction in the table
    // this.AlertMsg(b)
    this.firstForm.value.valid = false;
    this.loading = false;
    // OnPush: force CD so the [loading] input reaches gd-step2form and stops its spinner.
    this.cdr.detectChanges();
    return this.reRoute();
  }
  showToasts(duration) {
    const toastRef = this.toastrService.success(
      "success",
      `Your info has been saved.`
    );
  }
  reRoute() {
     if (this.versionbtn === "Removious") {
       this.showToasts(this.duration);
      return this.router.navigate(["/pages/dashboard"]);
    }
    // After saving: Trading Principal stays on the page; every other role
    // redirects to the pending transactions screen, loaded normally (no
    // transaction filter that would otherwise stick to a single transaction).
    if (this.isTradingPrincipalRole()) {
      return this.showToasts(this.duration);
    }
    this.showToasts(this.duration);
    sessionStorage.removeItem("blotterIdFiltered");
    // Clear only the transaction filter, keeping the user's selected view
    // button (Show All / Document Review / etc.).
    this.initUserService.clearPendingTransactionFilter();
    return this.router.navigate(["/pages/dashboard"]);
  }
  private isTradingPrincipalRole(): boolean {
    if (!this.storageValueReturn) {
      return false;
    }
    const role = decodeURI(
      CryptoJS.AES.decrypt(
        this.storageValueReturn.trim(),
        `${environment.securepw.trim()}`
      ).toString(CryptoJS.enc.Utf8)
    ).toUpperCase();
    return role === "TRADING PRINCIPAL";
  }
  SubmitblotterInfoError(): void {
    this.toastrService.error(
      "Your Form did not save, Please try again.",
      "Error"
    );
    this.firstForm.value.valid = true;
    this.loading = false;
    this.loadingDelete = false;
    // OnPush: force CD so the [loading]/[loadingDelete] inputs reach gd-step2form and stop its spinner.
    this.cdr.detectChanges();
    return;
  }
  showToast(
    status: 'success' | 'error' | 'info' | 'warning',
    message: string,
    position: string = 'toast-top-right',
    destroyByClick: boolean = true
  ) {
    // Pick the right toastr function based on status
    switch (status) {
      case 'success':
        this.toastrService.success(message, '', { positionClass: position, closeButton: destroyByClick });
        break;
      case 'error':
        this.toastrService.error(message, '', { positionClass: position, closeButton: destroyByClick });
        break;
      case 'info':
        this.toastrService.info(message, '', { positionClass: position, closeButton: destroyByClick });
        break;
      case 'warning':
        this.toastrService.warning(message, '', { positionClass: position, closeButton: destroyByClick });
        break;
      default:
        this.toastrService.show(message, '', { positionClass: position, closeButton: destroyByClick });
        break;
    }
  }
  showToastpst(message: string) {
    this.toastrService.success("", message);
  }
  public onFocus(combo) {
    if (!combo.isOpen) {
      combo.toggle(true);
    }
  }
  public onFocus2(combo2) {
    if (!combo2.isOpen) {
      combo2.toggle(true);
    }
  }
  /*
   * Rep
   */
  public selectionChange(event: any) {
    if (event) {
      this.showtrue = false;
      this.RepId = event.repId;
      this.GetRepCodeList(event.repId);
      this.GetClientListing(event.repId);
      this.RepSelected = event.repId;
      this.repNamestring = event.lastName;
      this.Email = event.email;
      this.firstForm.controls['clientTax'].enable();
      this.firstForm.controls['productTypeId'].enable();
    }
  }
  public selectionChangeRepCode(event: any) {
    if (event.repCode) {
      this.repCodestring = event.repCode;
      this.showtrue = false;
    }
  }

  /*
   * Client
   */
  public selectionChangeClient(event: any) {
    this.showtrue = false;
    this.clientId = event?.clientId;
    this.Clientstring = event?.firstName;
    this.taxen = event?.taxId;
    this.stateof = event?.state;
    this.InvObjectiveId = event?.invObjectiveId;
    this.LiquidityNeedsId = event?.liquidityNeedsId;
    this.InvestmentTimeHorizonId = event?.investmentTimeHorizonId;
    this.InvestmentProfileId = event?.investmentProfileId;
    this.AnnualIncFrom = event?.annualIncFrom;
    this.AnnualIncTo = event?.annualIncTo;
    this.NetWorthFrom = event?.netWorthFrom;
    this.NetWorthTo = event?.netWorthTo;
    this.LiquidNWFrom = event?.liquidNWFrom;
    this.LiquidNWTo = event?.liquidNWTo;
    this.InvestDescription = event?.investDescription;
    this.InvestmentTimeHorizonDescription =
      event?.investmentTimeHorizonDescription;
    this.ProfileDescription = event?.profileDescription;
    this.LiquidDescription = event?.liquidDescription;
    //  const myMoment: moment.Moment = moment(event?.dob);
    const parsedDate: Date | null = event?.dob
      ? parseISO(event.dob)
      : null;
    this.dob = format(parsedDate, 'MM-dd-yyyy');
    // this.dob = myMoment.format("MM-DD-YYYY");
    const clId = this.clientId?.toString();
    if (clId !== undefined) {
      localStorage.setItem("clId", clId.toString());
    }
    if (this.route.snapshot.queryParams["Rview"]) {
      //  this.editsource = true
      this.StatusTypeId = -2;
      sessionStorage.setItem("changeoftype", "true");
    }
  }
  NaviagetoPage() {
    const saveRepId = this.firstForm.get("RepId").value;
    const paramrepId = CryptoJS.AES.encrypt(
      encodeURI(saveRepId).trim(),
      environment.securepw.trim()
    ).toString();
    this.router.navigate(["/pages/AccountForm/add-account"], {
      queryParams: { reid: paramrepId }
    });
  }
  changestatus(v) {
    console.log('[changestatus] Called with v:', v, 'queryEdit:', this.queryEdit, 'counter before:', this.counter);
    this.firstForm.get("sourcetypes").setValue(v);
    this.SourceofFundsSelected = v;
    this.radstatus = "success";
    if (v === 11) {
      this.sourceselect = true;
    } else {
      this.sourceselect = false;
    }
    if (v === 15) {
      this.sourceselecttransfer = true;
    } else {
      this.sourceselecttransfer = false;
    }
    // Only check warning if not in edit mode (queryEdit === true means new transaction)
    if (this.queryEdit) {
      if (this.counter >= 1) {
        this.checkWarning = true;
        this.showtrue = false;
      } else {
        this.checkWarning = false;
        this.showtrue = true;
      }
      this.counter++;
    } else {
      // In edit mode (Rview), don't trigger check warning
      this.checkWarning = false;
      this.showtrue = true;
    }
    //console.log('[changestatus] After - checkWarning:', this.checkWarning, 'counter:', this.counter, 'showtrue:', this.showtrue);
  }
  /*
   *Transaction Type
   */
  selectionChangetypes(t) {
    this.firstForm.controls["SplitRepId"].setErrors({ incorrect: true });
    if (this.cnt !== 0) {
      this.firstForm.controls["transact"].setErrors({ incorrect: true });
    }
    this.cnt++;
    this.transactionTypeId = t.transactionTypeId;
    this.showtrue = false;
    this.source = false;
    this.onVal = false; // disable productType
    this.source = false; // Hide source of funds
    this.firstForm.controls["SplitRepId"].setErrors(null);
    if (this.ptypes === 14 || this.ptypes === 13) {
      this.source = false;
      this.accountformTrue = false;
      this.firstForm.controls["sourcetypes"].setValue(0);
      this.cdr.detectChanges();
      return;
    }
    if (t.transactionTypeId === 1 || t.transactionTypeId === 2) {
      this.source = true;
      this.accountformTrue = false;
      this.firstForm.controls["sourcetypes"].setValue("");
      this.cdr.detectChanges();
      return;
    }
    if (t.transactionTypeId === 3) {
      this.source = false;
      this.accountformTrue = false;
      this.firstForm.controls["sourcetypes"].setValue(0);
      this.cdr.detectChanges();
      return;
    }
    if (t.transactionTypeId === 4) {
      this.source = false;
      this.accountformTrue = false;
      this.firstForm.controls["sourcetypes"].setValue(0);
      this.cdr.detectChanges();
      return;
    }
    if (t.transactionTypeId === 5) {
      this.source = false;
      this.accountformTrue = true;
      this.firstForm.controls["sourcetypes"].setValue("");
      this.cdr.detectChanges();
      return;
      /*  if (this.roleString === 'INSURANCE') {
        this.firstForm.controls['productTypeId'].setValue(14)
        this.firstForm.controls.productTypeId.enable()
        this.firstForm.controls['sourcetypes'].setValue(0)
        this.cdr.detectChanges()
        return
      } */
    }
  }
  cpSubmit() {
    this.router.navigate(["/pages/AccountForm/add-account"], {
      queryParams: { Cld: this.clientId }
    });
  }
  handleFilter() {
    // show msg once change.
    const checktransvalue = this.firstForm.get("transact").value;
    const productTypeIds = this.firstForm.get("productTypeId").value;
    this.tester++;
    if (checktransvalue === 1) {
      if (
        productTypeIds === 14 ||
        productTypeIds === 13 ||
        productTypeIds === 15 ||
        productTypeIds === 18
      ) {
        this.firstForm.controls["sourcetypes"].setValue(0);
        this.source = false;
      } else {
        this.source = true;
      }
    }
    if (checktransvalue === 2) {
      if (
        productTypeIds === 14 ||
        productTypeIds === 13 ||
        productTypeIds === 18
      ) {
        this.firstForm.controls["sourcetypes"].setValue(0);
        this.source = false;
      } else {
        this.source = true;
      }
    }
    if (checktransvalue === 3) {
      this.firstForm.controls["sourcetypes"].setValue(0);
      this.firstForm.controls["SplitRepId"].setValue(0);
    }
    if (checktransvalue === 4) {
      this.firstForm.controls["SplitRepId"].setValue(0);
      this.firstForm.controls["sourcetypes"].setValue(0);
    }
    if (this.tester >= 0) {
      this.editsource = true;
      this.showtrue = false;
      this.checkWarning = true;
      this.showbtn = false;
      this.continuechanges = true;
      //  this.hidetoprow = false
      // this.show()
    } else {
      this.editsource = false;
      this.showtrue = true;
      this.checkWarning = false;
      this.showbtn = true;
      this.continuechanges = false;
    }
  }
  selectionChangeProductTypes(
    t: any,
    s?: any,
    tr?: any,
    split?: number,
    splitr?: number,
    repcodes?: number
  ) {
    this.firstForm.controls["SplitRepId"].setErrors({ incorrect: true });
    this.ptypes = null;
    this.ProdTypeId = t.productTypeId;
    this.producttypeIdEdit = t.productTypeId;
    this.showtrue = false;
    if (this.route.snapshot.queryParams["Rview"]) {
      this.transactionTypeId = tr != 0 ? tr : this.firstForm.value.transact;
      if (split === 0) {
        this.firstForm.get("SplitRepId2").setValue("false");
      } else {
        this.firstForm.get("SplitRepId2").setValue("true");
      }
      this.firstForm.get("transact").setValue(tr);
      if (split === 1) {
        this.firstForm.get("SplitRepId").setValue(splitr);
      }
      const pushtransactions = { transactionTypeId: tr };
      this.selectionChangetypes(pushtransactions);
    }
    if (t.productTypeId === 6) {
      this.GetSourceofFundTypes(7);
    }
    if (t.productTypeId === 4) {
      this.GetSourceofFundTypes(8);
    }
    if (t.productTypeId === 18) {
      this.GetSourceofFundTypes(8);
    }
    if (t.productTypeId === 2) {
      this.GetSourceofFundTypes(6);
    }
    if (t.productTypeId === 9) {
      this.GetSourceofFundTypes(5);
    }
    if (t.productTypeId === 7) {
      this.GetSourceofFundTypes(4);
    }
    if (t.productTypeId === 5) {
      this.GetSourceofFundTypes(3);
    }
    if (t.productTypeId === 16) {
      this.GetSourceofFundTypes(2);
    }
    if (t.productTypeId === 8) {
      this.GetSourceofFundTypes(1);
    }
    if (t.productTypeId === 10) {
      this.GetSourceofFundTypes(9);
    }
    if (t.productTypeId === 1) {
      this.GetSourceofFundTypes(11);
    }
    if (t.productTypeId === 12) {
      this.GetSourceofFundTypes(12);
    }
    if (t.productTypeId === 11) {
      this.GetSourceofFundTypes(13);
    }
    if (t.productTypeId === 3) {
      this.GetSourceofFundTypes(14);
    }
    if (t.productTypeId === 15) {
      this.GetSourceofFundTypes(14);
    }
    if (t.productTypeId === 17) {
      this.GetSourceofFundTypes(17);
    }
    if (t.productTypeId === 15) {
      this.GetSourceofFundTypes(15);
    }
    if (t.productTypeId === 13) {
      this.firstForm.controls["sourcetypes"].setValue(0);
    }
    if (t.productTypeId === 19) {
      this.firstForm.controls["sourcetypes"].setValue(0);
    }
    if (t.productTypeId === 18) {
      this.firstForm.controls["sourcetypes"].setValue(0);
    }
    /*  const productTypeIds = this.firstForm.get('transact').value
    if (productTypeIds.includes(13, 18, 19)) {
      this.source = false
    } else {
      this.source = true
    } */
    this.changestatus(s);
    setTimeout(() => {
      if (
        this.cdr !== null &&
        this.cdr !== undefined &&
        !(this.cdr as ViewRef).destroyed
      ) {
        this.firstForm.controls["SplitRepId"].setErrors(null);
        // this.cdr.detectChanges()
      }
    }, 250);

    /* const PauseEachLine = of(null)
    merge(
      PauseEachLine.pipe(
        map(() => this.show()),
        delay(100),
      ),
    ) */
    return;
  }
  selectValsplit(srp: any) {
    this.sourceoffundsstring = null;
    this.sourceoffundsstring = srp.label;
    this.showtrue = false;
    //   if (srp === 'true') {
    this.showsplit = true;
    // this.firstForm.controls['SplitRepId'].setValue('')
    this.editsource = true;
    this.showtrue = false;
    this.checkWarning = true;
    this.showbtn = false;
    this.continuechanges = true;
    return;
  }
  async sourceCheckTimeSelect(source: string) {
    if (!this.route.snapshot.queryParams["Rview"]) {
      this.firstForm.controls["sourcetypes"].setErrors({ incorrect: true });
      this.osjValid = await this.osjValidator(source);
      const repControl = this.firstForm.get("RepId");
      this.sourceoffundsstring = null;
      this.sourceoffundsstring = source;
      const TIME_ZONE = 'America/New_York';

      // 1. Get “now” in NY time:
      const currentTime: Date = toZonedTime(new Date(), TIME_ZONE);

      // 2. Build today’s date at 13:59:59 in NY time:
      const todayInZone = toZonedTime(new Date(), TIME_ZONE);
      const cutoffTime: Date = set(todayInZone, {
        hours: 13,
        minutes: 59,
        seconds: 59,
        milliseconds: 0
      });
      const repId = repControl.value;
      const rep: repingDto = await this.cliservice.getRepByIdAsync({
        repId: repId
      });
      /*   if (source === "Check" && currentTime.isAfter(cutoffTime)) {
          if (!rep.overrideOsjwarning) {
            this.checkWarningShowmsg = true;
          }
        } else {
          this.checkWarningShowmsg = false;
        } */
      if (this.counter >= 1) {
        this.editsource = true;
        this.showtrue = false;
        this.checkWarning = true;
        this.showbtn = false;
        this.continuechanges = true;
        this.cdr.detectChanges();
      } else {
        this.editsource = false;
        this.showtrue = true;
        this.checkWarning = false;
        this.showbtn = true;
        this.continuechanges = false;
        this.cdr.detectChanges();
      }
    }
  }
  isAfterOrBeforeTime(hour: number, before: boolean): boolean {
    const timezone = 'America/New_York';

    // “Now” in NY
    const nowInNY = toZonedTime(new Date(), timezone);

    // Today at (hour-1):59:59 in NY
    const cutoffInNY = set(
      toZonedTime(new Date(), timezone),
      {
        hours: hour - 1,
        minutes: 59,
        seconds: 59,
        milliseconds: 0
      }
    );
    return null;
  }

  public osjValidator = async (sourceType) => {
    // ##############  Get Current Role.  ###################
    const paramT = CryptoJS.AES.decrypt(
      this.storageValueReturn.trim(),
      `${environment.securepw.trim()}`
    ).toString(CryptoJS.enc.Utf8);
    const checkParamT = decodeURI(paramT); // ##############  Get Current Role.  ###################
    if (checkParamT === "REP") {
      this.RepExists = false;
    } else {
      this.RepExists = true;
    }
    const currentRole = checkParamT;
    const dateTime = new Date();
    const byHour = new Date(dateTime);
    const prodControl = this.firstForm.get("productTypeId");
    const repControl = this.firstForm.get("RepId");
    const transControl = this.firstForm.get("transact");
    const transId = transControl.value;
    const getvalues = this.productlisting.filter(
      (t) => t.productTypeId === prodControl.value
    );

    for (const i in getvalues) {
      this.newosjresult = getvalues[i].overrideOsjwarning;
    }
    if (
      (currentRole.toLowerCase() &&
        currentRole != null &&
        Number(byHour.getHours) > Number(this.newosjresult)) ||
      (Number(byHour.getHours) < 5 &&
        [1, 2, 7].includes(transId) &&
        ["rep", "branch access non manager", "branch manager"].includes(
          currentRole.toLowerCase()
        ))
    ) {
      if (sourceType != null) {
        const source = this.sourceFundtypelist.find(
          (y) => y.sourceOfFundsTypeDesc == sourceType
        );
        const repId = repControl.value;
        const sourceTypeValue = source.sourceOfFundsTypeId;
        const rep: repingDto = await this.cliservice.getRepByIdAsync({
          repId: repId
        });
        if (
          !rep.overrideOsjwarning &&
          rep.officeTypeId !== 2 &&
          (sourceTypeValue === 1 || sourceTypeValue === 9)
        ) {
          return true;
        }
        return false;
      }
    }
    return null;
  };

  /* ##################  Onload method ######################## */
  async osjValidatorload() {
    // ##############  Get Current Role.  ###################
    const paramT = CryptoJS.AES.decrypt(
      this.storageValueReturn.trim(),
      `${environment.securepw.trim()}`
    ).toString(CryptoJS.enc.Utf8)
    const checkParamT = decodeURI(paramT); // ##############  Get Current Role.  ###################
    if (checkParamT.toLowerCase() === "rep".toLowerCase()) {
      this.RepExists = false;
    } else {
      this.RepExists = true;
    }
    const currentRole = checkParamT;
    const dateTime = new Date();
    const byHour = new Date(dateTime);
    const prodControl = this.firstForm.get("productTypeId");
    const repControl = this.firstForm.get("RepId");
    const transControl = this.firstForm.get("transact");
    const transId = transControl.value;
    const getvalues = this.productlisting.filter(
      (t) => t.productTypeId === prodControl.value
    );
    for (const i in getvalues) {
      this.newosjresult = getvalues[i].overrideOsjwarning;
    }
    if (
      (currentRole &&
        currentRole != null &&
        Number(byHour.getHours) > Number(this.newosjresult)) ||
      (Number(byHour.getHours) < 5 &&
        [1, 2, 7].includes(transId) &&
        ["rep", "branch access non manager", "branch manager"].includes(
          currentRole.toLowerCase()
        ))
    ) {
      const sourceType = this.productlisting.filter(
        (t) => t.productTypeId === prodControl.value
      );
      if (sourceType != null) {
        const source = this.sourceFundtypelist.find(
          (y) => y.sourceOfFundsTypeDesc == sourceType
        );
        const repId = repControl.value;
        const sourceTypeValue = source.sourceOfFundsTypeId;
        const rep: repingDto = await this.cliservice.getRepByIdAsync({
          repId: repId
        });
        if (
          !rep.overrideOsjwarning &&
          rep.officeTypeId !== 2 &&
          (sourceTypeValue === 1 || sourceTypeValue === 9)
        ) {
          this.osjValid = true;
          return true;
        }
        this.osjValid = false;
        return false;
      }
      //  this.cdr.detectChanges()
    }
    return null;
  }
  continueCge() {
    sessionStorage.setItem("types", "changetypes");
    this.checkWarning = false;
    this.continuechanges = false;
    this.reloadStep2 = false;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.reloadStep2 = true;
      this.show();
      this.cdr.detectChanges();
    }, 100);
    setTimeout(() => this.show(), 1000);
  }
  continuecancel() {
    this.router.navigate(["/pages/dashboard"]);
  }
  public close(status: string): void {
    this.opened = false;
  }

  public open(): void {
    this.opened = true;
  }
  ngDestroy() {
    this.unsubcribe();
  }
}
